import { TawreedDataTableFilterMeta } from "../../../../common";
import { JObject } from "../../../../common/data/models";
import { DateUtils } from "../../../../helpers/date";
import { InvoiceReportParams } from "../../domain";

/**
 * 
 */
export const InvoiceReportParamsMapper = {

    /**
     *
     */
    fromJson: (dto: JObject): InvoiceReportParams => {
        return {
            startDate: dto.startDate,
            endDate: dto.endDate,
            partner: dto.partner ? dto.partner : undefined,
            invoiceNo: dto.invoiceNo,
        };
    },

    toJson: (dto: InvoiceReportParams): JObject => {
        return {
            startDate: DateUtils.toISO(dto.startDate, 'datetime', 'end'),
            endDate: DateUtils.toISO(dto.endDate, 'datetime', 'end'),
            partnerId: dto.partner ? dto.partner.partnerId : undefined,
            invoiceNo: dto.invoiceNo,
        };
    },

    toFilter: (dto: InvoiceReportParams): TawreedDataTableFilterMeta => {
        return {
            startDate: { operator: 'AND', constraints: [{ matchMode: 'equals', value: DateUtils.toISO(dto.startDate, 'date', 'end') }] },
            endDate: { operator: 'AND', constraints: [{ matchMode: 'equals', value: DateUtils.toISO(dto.endDate, 'date', 'end') }] },
            partnerId: { operator: 'AND', constraints: [{ matchMode: 'equals', value: dto.partner ? dto.partner.partnerId : null }] },
            invoiceNo: { operator: 'AND', constraints: [{ matchMode: 'equals', value: dto.invoiceNo }] },
        };
    },
}
